export default __webpack_public_path__ + "static/media/Stop.59a2e1ed.svg";